import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';
import { Page, Header } from 'components';
import ReportsAcceptanceDialogForm from './components/ReportsAcceptanceDialogForm';

import {
	GetAcceptanceReportsActivationDates
} from '../actions/ReportsAcceptanceActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const ReportsAcceptance = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(GetAcceptanceReportsActivationDates());
	}, []);

	return (
		<Page className={classes.root} title="Reports Acceptance">
			<Header module="Modules" view="Reports Acceptance" />
			<Grid className={classes.container} container spacing={1}>
				<Grid item lg={12} xs={12}>
					<ReportsAcceptanceDialogForm />
				</Grid>
			</Grid>
		</Page>
	);
};

export default ReportsAcceptance;
